// extracted by mini-css-extract-plugin
export default {"gamesTable":"GamesList_gamesTable__2PtaU","lastModifiedColumn":"GamesList_lastModifiedColumn__uAO+Q","infoColumn":"GamesList_infoColumn__SpJKh"};